import { GridColDef } from "@mui/x-data-grid";
import { UserRow } from "../types";
import { RoleCell } from "./RoleCell";
import { NameCell } from "./NameCell";
import { UserAvatarCell } from "./UserAvatarCell";

export const columns: GridColDef<UserRow>[] = [
  {
    field: "avatar",
    headerName: "",
    width: 50,
    resizable: false,
    sortable: false,
    renderCell: (params) => <UserAvatarCell name={params.row.name} />,
  },
  {
    field: "user",
    headerName: "User profile",
    minWidth: 300,
    flex: 1,
    resizable: false,
    sortable: false,
    renderCell: (params) => (
      <NameCell primary={params.row.name} secondary={params.row.email} />
    ),
  },
  {
    field: "role",
    headerName: "Organizational role",
    minWidth: 200,
    resizable: false,
    sortable: false,
    headerAlign: "right",
    renderCell: (params) => <RoleCell roles={params.row.roles} align="right" />,
  },
];
